var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.934,
    height: 54.291,
    viewBox: "0 0 53.934 54.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nature",
    transform: "translate(-1.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7336",
    "data-name": "Path 7336",
    d: "M86.731,387.066h-3.45v4.946h.739l2.71-4.7Z",
    transform: "translate(-72.946 -346.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7337",
    "data-name": "Path 7337",
    d: "M319.94,271.455l1.264-2.194h-1.169c-.319,0-.45-.226-.291-.5l3.375-5.857h-1.2a.554.554,0,0,1-.116-.012H315Z",
    transform: "translate(-280.098 -235.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7338",
    "data-name": "Path 7338",
    d: "M292.9,195.448h6.8c-.232-.049-.313-.251-.175-.491l1.841-3.2-2.486-4.314h-6.612l-1.987,3.449Z",
    transform: "translate(-257.993 -167.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7339",
    "data-name": "Path 7339",
    d: "M291.44,192.915l3.15-5.466h-2.324l-1.987,3.449Z",
    transform: "translate(-257.993 -167.573)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7340",
    "data-name": "Path 7340",
    d: "M290.329,108.777c-.319,0-.45-.226-.291-.5l4.969-8.623a.306.306,0,0,1,.578,0l4.969,8.623c.159.276.028.5-.291.5Z",
    transform: "translate(-257.719 -88.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7341",
    "data-name": "Path 7341",
    d: "M292.364,108.275l4.1-7.108-.873-1.515a.305.305,0,0,0-.578,0l-4.969,8.623c-.159.276-.028.5.291.5h2.324C292.335,108.777,292.2,108.551,292.364,108.275Z",
    transform: "translate(-257.719 -88.9)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7342",
    "data-name": "Path 7342",
    d: "M402.48,391.641v2.444l1.162,2.017h2.288v-4.461Z",
    transform: "translate(-358.298 -350.113)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    "data-name": "Path 7343",
    d: "M375.8,329.75l-3.907-6.78h-9.086l-1.264,2.194,2.932,5.088h11.034C375.832,330.252,375.963,330.026,375.8,329.75Z",
    transform: "translate(-321.705 -288.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    "data-name": "Path 7344",
    d: "M362.694,327.154l2.411-4.184h-2.294l-1.264,2.194Z",
    transform: "translate(-321.705 -288.723)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7345",
    "data-name": "Path 7345",
    d: "M371.133,268.855,367.757,263H362.5l-3.375,5.857c-.159.276-.028.5.291.5h11.425C371.161,269.357,371.292,269.131,371.133,268.855Z",
    transform: "translate(-319.481 -235.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    d: "M384.832,200.966c.319,0,.45-.226.291-.5l-3.831-6.649a.305.305,0,0,0-.578,0l-3.831,6.649c-.159.276-.028.5.291.5Z",
    transform: "translate(-335.353 -173.079)",
    fill: "#a0c663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    "data-name": "Path 7346",
    d: "M361.42,268.855,364.8,263H362.5l-3.375,5.857c-.159.276-.028.5.291.5h2.294C361.392,269.357,361.261,269.131,361.42,268.855Z",
    transform: "translate(-319.481 -235.111)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4883",
    "data-name": "Group 4883",
    transform: "translate(41.46 20.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    d: "M384.832,200.966c.319,0,.45-.226.291-.5l-3.831-6.649a.305.305,0,0,0-.578,0l-3.831,6.649c-.159.276-.028.5.291.5Z",
    transform: "translate(-376.813 -193.608)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    "data-name": "Path 7347",
    d: "M379.176,200.463l2.974-5.16-.858-1.489a.306.306,0,0,0-.578,0l-3.831,6.649c-.159.276-.028.5.291.5h2.294C379.148,200.965,379.017,200.739,379.176,200.463Z",
    transform: "translate(-335.354 -173.078)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7348",
    "data-name": "Path 7348",
    d: "M19.535,315.178l-4.1,7.12c-.159.276-.028.5.291.5H26.156l3.642-6.32-.751-1.3H19.535Z",
    transform: "translate(-12.231 -281.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7349",
    "data-name": "Path 7349",
    d: "M17.681,322.3l4.1-7.12H19.535l-4.1,7.12c-.159.276-.028.5.291.5h2.249C17.653,322.8,17.522,322.576,17.681,322.3Z",
    transform: "translate(-12.231 -281.759)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7350",
    "data-name": "Path 7350",
    d: "M52.178,258.554,48.632,252.4h-5.5l-3.547,6.155c-.159.276-.028.5.291.5H51.888C52.207,259.056,52.337,258.83,52.178,258.554Z",
    transform: "translate(-33.82 -225.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7351",
    "data-name": "Path 7351",
    d: "M41.831,258.554l3.547-6.155H43.129l-3.547,6.155c-.159.276-.028.5.291.5h2.249C41.8,259.056,41.672,258.83,41.831,258.554Z",
    transform: "translate(-33.82 -225.636)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7352",
    "data-name": "Path 7352",
    d: "M66.533,187.346c.319,0,.45-.226.291-.5l-4.038-7.007a.305.305,0,0,0-.578,0l-4.038,7.007c-.159.276-.028.5.291.5Z",
    transform: "translate(-50.436 -160.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7353",
    "data-name": "Path 7353",
    d: "M60.417,186.845l3.2-5.558-.835-1.449a.305.305,0,0,0-.578,0l-4.038,7.007c-.159.276-.028.5.291.5h2.249C60.389,187.347,60.258,187.121,60.417,186.845Z",
    transform: "translate(-50.435 -160.584)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7354",
    "data-name": "Path 7354",
    d: "M90.253,183.017l17.135-29.736,17.135,29.736Z",
    transform: "translate(-79.178 -137.028)",
    fill: "#f9a720"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7355",
    "data-name": "Path 7355",
    d: "M186.492,309.47c-4.18-1.8-8.6-14.511-8.6-14.511-.1-.3-.276-.3-.381,0,0,0-4.425,12.712-8.6,14.511Z",
    transform: "translate(-149.488 -263.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7356",
    "data-name": "Path 7356",
    d: "M283.347,362.726c-2.191-.943-4.448-4.882-6.1-8.42v8.42Z",
    transform: "translate(-246.343 -316.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7357",
    "data-name": "Path 7357",
    d: "M172.368,309.47c2.65-1.14,5.4-6.663,7.054-10.557-.957-2.249-1.551-3.954-1.551-3.954-.1-.3-.276-.3-.381,0,0,0-4.426,12.715-8.607,14.511Z",
    transform: "translate(-149.472 -263.481)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7358",
    "data-name": "Path 7358",
    d: "M107.388,153.281,90.253,183.017h3.471l15.4-26.724Z",
    transform: "translate(-79.178 -137.028)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7359",
    "data-name": "Path 7359",
    d: "M71.929,17.487a4.826,4.826,0,0,1-.022-9.652h0a.348.348,0,0,1,.316.493,4.133,4.133,0,0,0,3.742,5.864h.021a.348.348,0,0,1,.316.493A4.835,4.835,0,0,1,71.929,17.487Z",
    transform: "translate(-58.49 -7.004)",
    fill: "#f9a720"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7360",
    "data-name": "Path 7360",
    d: "M73.982,17.319a4.824,4.824,0,0,1-2.99-8.6,4.825,4.825,0,1,0,3.932,8.51A4.777,4.777,0,0,1,73.982,17.319Z",
    transform: "translate(-58.491 -7.79)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7361",
    "data-name": "Path 7361",
    d: "M64.923,11.314a5.668,5.668,0,0,0,5.129-3.285,1.179,1.179,0,0,0-1.07-1.673h-.03a3.3,3.3,0,0,1-2.978-4.685A1.179,1.179,0,0,0,64.9,0a5.657,5.657,0,0,0,.026,11.314ZM64.187,1.73a4.968,4.968,0,0,0,4,6.227,3.99,3.99,0,1,1-4-6.227Z",
    transform: "translate(-51.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7362",
    "data-name": "Path 7362",
    d: "M68.7,463.291a.831.831,0,0,0-.831-.831H63.252a.831.831,0,0,0,0,1.662h4.614A.831.831,0,0,0,68.7,463.291Z",
    transform: "translate(-54.298 -413.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7363",
    "data-name": "Path 7363",
    d: "M236.918,464.122h4.614a.831.831,0,0,0,0-1.662h-4.614a.831.831,0,0,0,0,1.662Z",
    transform: "translate(-209.549 -413.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7364",
    "data-name": "Path 7364",
    d: "M167.136,463.291a.831.831,0,0,0-.831-.831h-2.93a.831.831,0,0,0,0,1.662h2.93A.831.831,0,0,0,167.136,463.291Z",
    transform: "translate(-143.804 -413.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7365",
    "data-name": "Path 7365",
    d: "M319.47,462.46h-2.93a.831.831,0,0,0,0,1.662h2.93a.831.831,0,0,0,0-1.662Z",
    transform: "translate(-280.728 -413.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7366",
    "data-name": "Path 7366",
    d: "M409.465,462.46h-2.93a.831.831,0,1,0,0,1.662h2.93a.831.831,0,1,0,0-1.662Z",
    transform: "translate(-361.18 -413.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7367",
    "data-name": "Path 7367",
    d: "M108.1,496.327h-4.614a.831.831,0,1,0,0,1.662H108.1a.831.831,0,1,0,0-1.662Z",
    transform: "translate(-90.268 -443.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7368",
    "data-name": "Path 7368",
    d: "M280.921,496.327h-4.614a.831.831,0,0,0,0,1.662h4.614a.831.831,0,1,0,0-1.662Z",
    transform: "translate(-244.761 -443.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M205.694,496.327h-2.93a.831.831,0,1,0,0,1.662h2.93a.831.831,0,1,0,0-1.662Z",
    transform: "translate(-179.016 -443.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    d: "M369.8,496.327h-2.93a.831.831,0,1,0,0,1.662h2.93a.831.831,0,1,0,0-1.662Z",
    transform: "translate(-325.723 -443.698)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7371",
    "data-name": "Path 7371",
    d: "M54.786,118.3H48.463v-2.8h5.345a1.13,1.13,0,0,0,1.011-1.748l-.912-1.582a.831.831,0,1,0-1.44.83l.483.839h-9.7L40.8,109.585l.785-1.363h8.126l1.031,1.79a.831.831,0,1,0,1.44-.83l-.568-.986a1.136,1.136,0,0,0,.791-.537,1.176,1.176,0,0,0-.034-1.185L49.7,101.843a1.14,1.14,0,0,0,.82-.543,1.176,1.176,0,0,0-.034-1.185l-3.831-6.649a1.129,1.129,0,0,0-2.018,0l-1.27,2.2-1.048-1.818h.223A1.13,1.13,0,0,0,43.555,92.1l-4.968-8.622a1.129,1.129,0,0,0-2.018,0L31.6,92.1a1.13,1.13,0,0,0,1.011,1.748h.224l-.55.954-3.111-5.4,3.653-6.339a.831.831,0,1,0-1.44-.83l-3.177,5.513-3.177-5.513a.831.831,0,1,0-1.44.83l3.653,6.339-8.763,15.208-2.238-3.884a1.153,1.153,0,0,0,.9-.554,1.177,1.177,0,0,0-.034-1.185l-4.038-7.007a1.129,1.129,0,0,0-2.018,0L7.013,98.992a1.177,1.177,0,0,0-.034,1.185,1.153,1.153,0,0,0,.9.554l-2.834,4.918a1.176,1.176,0,0,0-.033,1.185,1.148,1.148,0,0,0,.865.551l-3.392,5.887a1.13,1.13,0,0,0,1.011,1.748H9.5V118.3H2.514a.831.831,0,0,0,0,1.662H54.786a.831.831,0,0,0,0-1.662ZM50.5,106.561H40.794l2.707-4.7h4.3ZM38.967,106.4l-2.623-4.551h5.245Zm6.682-11.359,2.972,5.157H42.677ZM36.96,92.191H33.468l4.109-7.131,4.109,7.131H40.062a.831.831,0,0,0,0,1.662H40.4l2.007,3.483-1.6,2.78c-.014.024-.025.05-.037.074H35.386l-2.143-3.72,1.508-2.618h2.208a.831.831,0,0,0,0-1.662Zm-24.9,1.371,3.178,5.516H8.882Zm-7.71,19.8L7.785,107.4h4.135a.831.831,0,0,0,0-1.662H6.911l2.878-4.995h4.542l2.878,4.995h-2.3a.831.831,0,0,0,0,1.662h1.424l.272.472-3.163,5.489Zm6.816,3.954v-2.292h1.321Zm18.905.993h-8.23a25.7,25.7,0,0,0,3.805-5.947c1.109-2.226,2.011-4.428,2.562-5.857.43,1.115,1.074,2.7,1.862,4.4v7.4Zm1.662,0v-4.118a21.216,21.216,0,0,0,2.845,4.118Zm5.459,0c-.971-.492-2.619-2.047-4.928-6.676a71.039,71.039,0,0,1-3.081-7.278,1,1,0,0,0-1.95,0,70.986,70.986,0,0,1-3.081,7.278c-2.309,4.629-3.957,6.184-4.928,6.676H12.512l15.7-27.241,15.7,27.241Zm9.608,0h-.977l-.811-1.408V115.5H46.8v2.8Z",
    transform: "translate(0 -73.145)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.3db335f587826de55dd5f018dd160363.svg";
export { ForwardRef as ReactComponent };